import { useTranslation } from 'react-i18next';
import React, { useCallback, useState, useEffect, Fragment } from 'react';
import {
  Button,
  TextField,
  MenuItem,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
  Box,
  Checkbox,
  FormControlLabel,
  CircularProgress
} from '@mui/material';
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'
import Autocomplete from '@mui/material/Autocomplete';
import { DateTextField, FileUploadComponent } from '../../lib';

export default function InputBox(props) {
  const { open, onClose, title, subtitle, fragen, handleResponse, buttonClick, turnuskey, hdokkey, nurbuttons, noDialog } = props;
  const [answers, setAnswers] = useState([]);
  const [selectedFile, setSelectedFile] = useState({});
  const [, updateState] = useState();
  const forceUpdate = useCallback(() => updateState({}), []);
  const { t } = useTranslation();
  useEffect(() => {
    var initialAnswers = fragen?.map((element) => {
      var initialValue = formatAnswer(element, element.INITWERT);
      return ({ 'key': element.KEY, antwort: initialValue })
    })
    if (initialAnswers === undefined) {
      initialAnswers = [];
    }
    setAnswers(initialAnswers);
    forceUpdate();
  }, [fragen]);

  const drawButtons = () => {
    return (
      <>
        <Button onClick={() => onClose()} color="primary">
          {t("Abbrechen")}
        </Button>
        {nurbuttons !== "1" &&
          <Button onClick={() => handleResponse(answers, selectedFile)} variant="contained" color="primary" autoFocus>
            {t("Antworten abgeben")}
          </Button>
        }
      </>
    )
  }
  const formatAnswer = (element, value) => {
    const format = element.FORMAT;
    if (format === undefined) return value;
    if (format === "") return value;
    var tmpValue = value;
    var tmpValueLength = value.length;
    var newValue = '';
    const formatLength = Number(element.LEN);
    var valueIndex = 0;
    var formatIndex = 0;
    if (tmpValueLength > formatLength) {
      if (value[0] !== ' ' && value[0] !== '0') {
        tmpValue = tmpValue.slice(0, formatLength);
        tmpValueLength = tmpValue.length;
      }
    }
    while (formatIndex < formatLength) {
      const tmpFormatkey = format[formatLength - formatIndex - 1];
      var tmpValuekey = tmpValue[tmpValueLength - valueIndex - 1] || ' ';
      switch (tmpFormatkey) {
        case '0':
          if (tmpValuekey !== '.' && tmpValuekey !== ' ') {
            newValue = tmpValuekey + newValue;
          } else if (tmpValuekey !== '.') {
            newValue = '0' + newValue;
          } else {
            formatIndex--
          }
          break;
        case '#':
          if (tmpValuekey === '0') {
            if (Number(tmpValue.slice(0, tmpValueLength - valueIndex - 1)) === 0) {
              newValue = ' ' + newValue;
            } else {
              newValue = '0' + newValue;
            }
          } else if (tmpValuekey !== '.') {
            newValue = tmpValuekey + newValue;
          } else {
            formatIndex--
          }
          break;
        case '.':
          if (tmpValuekey !== '.') {
            newValue = '.' + newValue;
            valueIndex--;
          } else {
            newValue = '.' + newValue;
          }
          break;
        case ':':
          if (tmpValuekey !== ':') {
            newValue = ':' + newValue;
            valueIndex--;
          } else {
            newValue = ':' + newValue;
          }
          break;
        default:
          newValue = tmpValuekey + newValue;
          break;
      }
      valueIndex++
      formatIndex++
    }
    return newValue;
  }

  const inputBoxFragen = useCallback(
    () => {
      const writeAnswer = (answerNumber, value) => {
        const tmpAnswers = answers.slice();
        tmpAnswers[answerNumber].antwort = value;
        setAnswers(tmpAnswers);
      }
      const writeNumberAnswer = (answerNumber, value) => {
        if (!isNaN(Number(value))) {
          console.log(Number(value));
          const tmpAnswers = answers.slice();
          tmpAnswers[answerNumber].antwort = value;
          setAnswers(tmpAnswers);
        }
      }
      const writeFormatedAnswer = (element, answerNumber, value) => {
        if (element.FELDART === "CHECKBOX") {
          if (value) { value = "1" } else { value = "0" }
        }
        if (!isNaN(Number(value))) {
          const newValue = formatAnswer(element, value);
          const tmpAnswers = answers.slice();
          tmpAnswers[answerNumber].antwort = newValue;
          setAnswers(tmpAnswers);
        }
      }


      const onSelectedFileChange = (key, answerNumber, value) => {

        setSelectedFile({ [key]: value })
        const tmpAnswers = answers.slice();
        tmpAnswers[answerNumber].antwort = value.name;
        console.log(tmpAnswers);
        setAnswers(tmpAnswers);
        console.log(value.name);
      }

      var alleFragen = null;
      alleFragen = fragen?.map((element, count) => {
        var frageElement = null;
        switch (element.FELDART) {
          case 'HDOK':
            frageElement =
              <>
                <Grid item xs={12}>
                  <Button
                    key={'Frage' + count.toString()}
                    onClick={() => buttonClick(element.FELDART)}
                    color="primary"
                    variant="outlined"
                    fullWidth
                  >
                    {element.TEXT}
                  </Button>
                </Grid>

                <Grid item xs={12}>
                  <Typography align="center" color="error"  >{((hdokkey && hdokkey !== answers[count]?.antwort) ? "Der Ablagename wurde verändert! Um die Änderungen zu Übernehmern müssen die Antworten abgegeben werden" : "")}</Typography>
                </Grid>
              </>
            break;
          case 'TURNUS':
            frageElement =
              <>
                <Grid item xs={12}>
                  <Button
                    key={'Frage' + count.toString()}
                    onClick={() => buttonClick(element.FELDART)}
                    color="primary"
                    variant="outlined"
                    fullWidth
                  >
                    {element.TEXT}
                  </Button>
                </Grid>

                <Grid item xs={12}>
                  <Typography align="center" color="error"  >{((turnuskey && turnuskey !== answers[count]?.antwort) ? "Der Turnus wurde verändert! Um die Änderungen zu Übernehmern müssen die Antworten abgegeben werden" : "")}</Typography>
                </Grid>
              </>
            break;
          case 'DMSDOK':
            frageElement =
              <Grid item xs={12} key={'Frage' + count.toString()}>
                <Button
                  key={'Frage' + count.toString()}
                  onClick={() => buttonClick(element.KEY, element?.DMSNR)}
                  color="primary"
                  variant="outlined"
                  fullWidth
                >
                  {element.TEXT}
                </Button>
              </Grid>
            break;
          case 'SCHNELLAW':
            frageElement =
              <Grid item xs={12} key={'Frage' + count.toString()}>
                <Button
                  key={'Frage' + count.toString()}
                  onClick={() => buttonClick(element.KEY)}
                  color="primary"
                  variant="outlined"
                  fullWidth
                >
                  {element.TEXT}
                </Button>
              </Grid>
            break;
          case 'DROPBOX':
            frageElement =
              <Grid item xs={12} key={'Frage' + count.toString()}>
                <TextField
                  select
                  key={'Frage' + count.toString()}
                  variant="outlined"
                  label={element.TEXT}
                  value={answers[count]?.antwort || ""}
                  onChange={(event) => writeAnswer(count, event.target.value)}
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                >
                  {element?.DROPDOWN?.length > 0 ?
                    element?.DROPDOWN?.map((dropBoxValue) => {
                      return (<MenuItem key={dropBoxValue.tbl} value={dropBoxValue.tbl}>{dropBoxValue.vorgabe}</MenuItem>);
                    })
                    :
                    element.VGINHALT?.split("\r\n").map((dropBoxValue) => {
                      return (<MenuItem key={dropBoxValue} value={dropBoxValue}>{dropBoxValue}</MenuItem>);
                    })}
                </TextField>
                {element.INFOHTML &&
                  <Box pl={1} pt={1} pb={2}>
                    {element.INFOHTML?.split('<br>').map((text) => {
                      return (<Typography variant='body2' >{text}</Typography>);
                    })}
                  </Box>
                }
              </Grid>
            break;
          case 'ZAHLENFELDPOS':
            frageElement =
              <Grid item xs={12} key={'Frage' + count.toString()}>
                <TextField
                  variant="outlined"
                  key={'Frage' + count.toString()}
                  label={element.TEXT}
                  value={answers[count]?.antwort}
                  onChange={(event) => writeFormatedAnswer(element, count, event.target.value)}
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
                {element.INFOHTML &&
                  <Box pl={1} pt={1} pb={2}>
                    {element.INFOHTML?.split('<br>').map((text) => {
                      return (<Typography variant='body2' >{text}</Typography>);
                    })}
                  </Box>
                }
              </Grid>
            break
          case 'MULTI_LINE':
            frageElement =
              <Grid item xs={12} key={'Frage' + count.toString()}>
                <TextField
                  variant="outlined"
                  label={element.TEXT}
                  key={'Frage' + count.toString()}
                  value={answers[count]?.antwort}
                  autoFocus={count === 0}
                  helperText={element.INFOHTML}
                  onChange={(event) => writeFormatedAnswer(element, count, event.target.value)}
                  multiline={element?.MULTI}
                  rows={element?.ROWS ? element.ROWS : "1"}
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
            break
          case 'MEHRZEILIG':
            frageElement =
              <Grid item xs={12} key={'Frage' + count.toString()}>
                <TextField
                  variant="outlined"
                  label={element.TEXT}
                  key={'Frage' + count.toString()}
                  value={answers[count]?.antwort}
                  autoFocus={count === 0}
                  helperText={element.INFOHTML}
                  multiline={element?.MULTI}
                  rows={element?.ROWS ? element.ROWS : "1"}
                  onChange={(event) => writeAnswer(count, event.target.value)}
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
            break
          case 'EINGABE':
            frageElement =
              <Grid item xs={12} key={'Frage' + count.toString()}>
                <TextField
                  variant="outlined"
                  label={element.TEXT}
                  value={answers[count]?.antwort}
                  key={'Frage' + count.toString()}
                  autoFocus={count === 0}
                  helperText={element.INFOHTML}
                  onChange={(event) => writeFormatedAnswer(element, count, event.target.value)}
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
            break
          case 'DATUM_INVERS':
            frageElement =
              <Grid item xs={12} key={'Frage' + count.toString()}>
                <DateTextField
                  variant="outlined"
                  key={'Frage' + count.toString()}
                  label={element.TEXT}
                  value={answers[count]?.antwort}
                  autoFocus={count === 0}
                  helperText={element.INFOHTML}
                  onChange={(event) => writeAnswer(count, event.target.value)}
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
            break
          case "CHECKBOX":
            frageElement =
              <Grid item xs={12} key={'Frage' + count.toString()}>
                <FormControlLabel
                  control={
                    <Checkbox
                      icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                      checkedIcon={<CheckBoxIcon fontSize="small" />}
                      checked={(answers[count]?.antwort === "1")}
                      key={'Frage' + count.toString()}
                      onChange={(e) => { writeFormatedAnswer(element, count, e.target.checked); }}
                    />
                  }
                  label={element.TEXT}
                />
              </Grid>
            break
          case 'TITEL':
            frageElement =
              <Grid item xs={12} key={'Frage' + count.toString()}>
                <Typography align="center" color="primary" id={element.key} fullWidth key={'Frage' + count.toString()}  > {element.TEXT} </Typography>
              </Grid>
            break
          case 'EXPLORER_NEU':
            frageElement =
              <Grid item xs={12} key={'Frage' + count.toString()}>
                <FileUploadComponent variant="contained" children={element.TEXT} color="primary" id="file-input" key={'Frage' + count.toString()} onChange={(f) => onSelectedFileChange(element.KEY, count, f)} />
                {selectedFile[element.KEY] ? <span ><Typography >{selectedFile[element.KEY].name}</Typography></span> : <Typography color="textSecondary" >{"Keine Datei ausgewählt"}</Typography>}

              </Grid>
            break
          case 'INFOFELD':
            frageElement =
              <Grid item xs={12} key={'Frage' + count.toString()}>
                <TextField
                  variant="outlined"
                  label={element.TEXT}
                  value={answers[count]?.antwort}
                  disabled={true}
                  key={'Frage' + count.toString()}
                  autoFocus={count === 0}
                  helperText={element.INFOHTML}
                  onChange={(event) => writeFormatedAnswer(element, count, event.target.value)}
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
            break
          default:
            break;
        }
        return (frageElement);
      });
      return (alleFragen);
    },
    [fragen, answers, turnuskey, hdokkey, selectedFile],
  )
  if (noDialog) {
    return (
      <Grid container spacing={2}>
        {subtitle &&
          <Grid item xs={12}>
            <Box pl={1} pt={1} pb={2}>
              {subtitle?.split('<br>').map((subtitle) => {
                return (<Typography variant='body2' >{subtitle}</Typography>);
              })}
            </Box>
          </Grid>
        }
        {inputBoxFragen()}
        <Grid item xs={12} >
          {drawButtons()}
        </Grid>
      </Grid>
    )
  }
  return (
    <Dialog
      open={open}
      fullWidth
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <Box pt={1}>
          <Grid container spacing={2}>
            {subtitle &&
              <Grid item xs={12}>
                <Box pl={1} pt={1} pb={2}>
                  {subtitle?.split('<br>').map((subtitle) => {
                    return (<Typography variant='body2' >{subtitle}</Typography>);
                  })}
                </Box>
              </Grid>
            }
            {inputBoxFragen()}
          </Grid>
        </Box>
      </DialogContent>
      <DialogActions>
        {drawButtons()}
      </DialogActions>
    </Dialog>
  );
}
